import React, { useEffect, useState } from 'react';
import DocumentTitle from 'react-document-title';
import { Col, Row } from 'reactstrap';
import { isEmpty } from 'lodash';
import { Element, scroller } from 'react-scroll';
import ApiLoader from '../loading/ApiLoader';
import CoverBig from '../containers/CoverBig';
import { useAxiosHook } from '../../hooks/ApiHooks';
import api from '../../apiConfig';
import Book from '../containers/Book';
import CheckAlso from '../containers/CheckAlso';
import SearchBox from '../containers/SearchBox';
import ReadingsPagination from '../utils/ReadingsPagination';

const Author = ({ match }) => {
  const slug = match.params.slug;
  const [authorID, setAuthorID] = useState(0);
  const [currPageNo, setcurrPageNo] = useState(1);
  const [authorData, getAuthorData] = useAxiosHook(api.dataController, `${api.authorData}/${slug}`);
  const [authorBooks, getAuthorBooks] = useAxiosHook(
    api.dataController,
    `${api.authorBooksData}/${authorID}`,
    'get',
    null,
    {
      params: { page: currPageNo, per_page: 8, orderby: 'title', order: 'asc' }
    }
  );

  useEffect(() => {
    getAuthorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const { data } = authorData;
  const { id, title, author_bio, author_profile_pic, link_author_link, project_author_link } = !isEmpty(data) && data;

  const books = (authorBooks.data && authorBooks.data.elements) || [];
  const totalPages = (authorBooks.data && authorBooks.data.totalPages) || 0;

  useEffect(() => {
    id && setAuthorID(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    authorID !== 0 && getAuthorBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorID]);

  const changePageNo = pageNo => {
    setcurrPageNo(pageNo);
    scroller.scrollTo('book-list', { duration: 500, smooth: true });
  };

  useEffect(() => {
    authorID !== 0 && getAuthorBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currPageNo]);

  return (
    <div className="full-wrapper flex-grow-1 subpage-margins">
      <ApiLoader status={authorData.apiStatus}>
        {!isEmpty(data) && (
          <>
            <DocumentTitle title={title} />
            <section className="content-wrapper">
              <SearchBox />

              <h1 className="main-header">
                <span>Autorzy</span>
              </h1>

              <Row className="reading-about-section">
                <Col xs={12} md={6} className="mb-5 mb-md-0">
                  <CoverBig cover={author_profile_pic} />
                </Col>
                <Col xs={12} md={6}>
                  <h2 className="custom-h2">{title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: author_bio }} className="reading-book-about" />
                </Col>
              </Row>
            </section>
          </>
        )}
      </ApiLoader>
      <Element name="book-list">
        <section className="content-wrapper">
          <ApiLoader status={authorBooks.apiStatus}>
            <Row>
              <Col xs={12}>
                <h5 className="main-header checkAlso-projects-header mt-5">
                  <span>Utwory</span>
                </h5>
              </Col>
            </Row>
            <Row>
              {books.map((book, idx) => (
                <Col xs="12" sm="6" lg="3" key={idx} className="mb-30">
                  <Book title={book.title} author={book.author_book_link} cover={book.book_cover} slug={book.slug} />
                </Col>
              ))}
            </Row>
            <ReadingsPagination totalPages={totalPages} currPageNo={currPageNo} changePageNo={changePageNo} />
            <CheckAlso pages={link_author_link} projects={project_author_link} />
          </ApiLoader>
        </section>
      </Element>
    </div>
  );
};

export default Author;
